import { createAction, props } from '@ngrx/store';

import BetslipActions from '../../base/store/actions';

export class InfoMessagesActions {
    static readonly ACTION_SCHEMA = `${BetslipActions.ACTION_SCHEMA}/info-messages`;
    private static readonly TOGGLE = `${InfoMessagesActions.ACTION_SCHEMA}/TOGGLE`;
    private static readonly CLOSE_BY_ID = `${InfoMessagesActions.ACTION_SCHEMA}/CLOSE`;
    static toggle = createAction(InfoMessagesActions.TOGGLE, props<{ messageId: string }>());
    static closeById = createAction(InfoMessagesActions.CLOSE_BY_ID, props<{ messageId: string }>());
}
